import { useContext } from "react";

import { MktgDataContext } from "../MktgDataProvider";

export const useAdobeData = () => {
  const { adobeData } = useContext(MktgDataContext);

  return { adobeData };
};

export const getAdobeDataLayerItem = (adobeData, path) => {
  let value;

  if (path && path.split) {
    const pathItems = path.split(".");

    value = pathItems.reduce(
      (current, pathItem) => (current && current[pathItem] ? current[pathItem] : null),
      { adobeDataLayer: adobeData }
    );
  }

  return value;
};
